import { Box } from "@mui/material";
import styled from "styled-components";

export const LeadStaticFieldContainer = styled(Box)`
    width: 100%;
    div::after {
        content: "";
        position: absolute;
        top: .39rem;
        left: .05rem;
        width: 10px;
        height: 3.08rem;
        z-index: -1;
        background-color: #9E9E9E;

        border-radius: 4px 0 0 4px;
    }
    label {
        padding-left: 6px;
    }
    input{
        padding-left: 1.2rem !important;
    }

    // mui form control over ride
    .MuiFormControl-root{
        width: 100%;
    }
`;


export default { LeadStaticFieldContainer };